import { createOptimizedContext } from '../createOptimizedContext';

export const {
  Provider: CatalogListProvider,
  useStoreSelector: useCatalogListSelector,
  useStoreDispatch: useCatalogListDispatch,
  useStore: useCatalogListStore
} = createOptimizedContext<{ selectedIndexes: Set<number> }>({
  selectedIndexes: new Set<number>()
});
